export class MachineManufacturer {
    Id: number;
    name: string;
    is_active: boolean;
}